export default __webpack_public_path__ + "25538c31a0ae6b6c90082d0609ebd63a.svg";